import { createAction } from "@reduxjs/toolkit";
import {
  addSubscriptionDetailsPostsActionType,
  setSubscriptionDetailsActionType,
  setSubscriptionDetailsPostsActionType,
} from "./actionTypes";

export const setSubscriptionDetails = createAction(
  setSubscriptionDetailsActionType,
);

export const setSubscriptionDetailsPosts = createAction(
  setSubscriptionDetailsPostsActionType,
);

export const addSubscriptionDetailsPosts = createAction(
  addSubscriptionDetailsPostsActionType,
);
